import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import { AddDamagedPersonParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAddDamagedPerson/addDamagedPersonQuery.type';
import { DamagedPersonFormData } from '@/modules/adjusterReportModules/IncidentParticipants/types/addDamagedPerson.type';

const useAddDamagedConvertData = () => {
  const convertData = ({
    data,
  }: {
    data: DamagedPersonFormData;
  }): AddDamagedPersonParamsType['formData'] => {
    if (data.damaged_type === 'VEHICLE') {
      switch (data.owner_type) {
        case 'real':
          return {
            damaged_type: data.damaged_type,
            owner_type: data.owner_type,
            real: {
              first_name: data.first_name,
              last_name: data.last_name,
              gender: data.gender,
              national_code: data.national_code,
              phone_number: data.phone_number,
              vehicle_type: data.vehicle_type.value,
              vehicle_plate: data.plate.plateString,
              vehicle_plate_design: data.vehicle_plate_design.value,
            },
          };
        case 'legal':
          return {
            damaged_type: data.damaged_type,
            owner_type: data.owner_type,
            legal: {
              name: data.name,
              phone_number: data.phone_number,
              vehicle_type: data.vehicle_type.value,
              vehicle_plate: data.plate.plateString,
              vehicle_plate_design: data.vehicle_plate_design.value,
            },
          };
      }
    }
    if (data.damaged_type === 'OTHER') {
      switch (data.owner_type) {
        case 'real':
          return {
            damaged_type: data.damaged_type,
            owner_type: data.owner_type,
            real: {
              first_name: data.first_name,
              last_name: data.last_name,
              gender: data.gender,
              national_code: data.national_code,
              phone_number: data.phone_number,
              birthdate: convertPersianToGregorian(
                data?.birthdate.toString() ?? '',
              ),
              city_code: data.city_code,
              phone: data.phone,
            },
          };
        case 'legal':
          return {
            damaged_type: data.damaged_type,
            owner_type: data.owner_type,
            legal: {
              name: data.name,
              owner_economic_code: data.owner_economic_code,
              owner_registration_number: data.owner_registration_number,
              owner_identity_number: data.owner_identity_number,
              phone_number: data.phone_number,
            },
          };
      }
    }

    throw new Error('Invalid damaged_type or owner_type');
  };
  return { convertData };
};

export default useAddDamagedConvertData;
